import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "uk-padding uk-padding-remove-horizontal uk-padding-remove-bottom about-highlight" }
const _hoisted_2 = { class: "uk-container" }
const _hoisted_3 = { class: "uk-grid" }
const _hoisted_4 = { class: "uk-width-1-3@xl uk-width-1-3@l uk-width-1-2@m uk-margin-medium-top" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "uk-width-2-3@xl uk-width-2-3@l uk-width-1-2@m" }
const _hoisted_7 = { class: "uk-margin-remove-bottom uk-margin-small-top" }
const _hoisted_8 = { class: "impx-text-large uk-margin-medium-bottom uk-margin-small-top" }
const _hoisted_9 = {
  class: "uk-child-width-1-2@xl uk-child-width-1-2@l uk-child-width-1-2@m uk-child-width-1-2@s impx-features-hl uk-margin-top uk-grid-match uk-flex-center uk-margin-medium-bottom",
  "data-uk-grid": ""
}
const _hoisted_10 = {
  class: "uk-grid-medium",
  "data-uk-grid": ""
}
const _hoisted_11 = { class: "uk-width-auto@xl uk-width-auto@l uk-width-auto@l uk-width-auto@s" }
const _hoisted_12 = { class: "uk-width-expand@xl uk-width-expand@l uk-width-expand@l uk-width-auto@s impx-margin-top-remove" }
const _hoisted_13 = { class: "uk-margin-remove" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "uk-margin-small-top" }
const _hoisted_16 = { class: "uk-container" }
const _hoisted_17 = { class: "uk-flex uk-flex-right" }
const _hoisted_18 = { class: "uk-width-1-1@xl uk-width-1-1@l uk-width-1-3@m uk-width-1-1@s" }
const _hoisted_19 = { class: "bg-color-csa uk-padding impx-padding-medium uk-margin-medium-bottom uk-box-shadow-medium" }
const _hoisted_20 = { class: "impx-hp-booking-form side-form uk-margin-bottom uk-margin-remove-top" }
const _hoisted_21 = { class: "uk-margin" }
const _hoisted_22 = { class: "uk-form-controls" }
const _hoisted_23 = { class: "uk-inline" }
const _hoisted_24 = { class: "uk-margin" }
const _hoisted_25 = { class: "uk-form-controls" }
const _hoisted_26 = { class: "uk-inline" }
const _hoisted_27 = { class: "uk-margin" }
const _hoisted_28 = { class: "uk-form-controls" }
const _hoisted_29 = { class: "uk-inline" }
const _hoisted_30 = { class: "uk-margin" }
const _hoisted_31 = { class: "uk-form-controls" }
const _hoisted_32 = { class: "uk-inline" }

import {getCurrentInstance, reactive, ref} from "vue";
import LoadingSpinner from "@/shared/components/loading/LoadingSpinner.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactForm',
  props: {
  title: {type: String, default: ''},
  subtitle: {type: String, default: ''},
  bgImageUrl: {type: String, default: ''},
  socialLink: {type: Array as () => string[], default: () => []}
},
  setup(__props) {

const {$alert} = getCurrentInstance().appContext.config.globalProperties;
const {$axios} = getCurrentInstance().appContext.config.globalProperties;
const {$endpoint} = getCurrentInstance().appContext.config.globalProperties;
const load = ref(false)
const contactForm = reactive({
  client_full_name: "",
  client_email: "",
  client_object: "",
  client_message: "",
})
const contactValidator = () => {
  return contactForm.client_full_name == "" || contactForm.client_email == "" || contactForm.client_object == "" || contactForm.client_message == ""
}
const sendMessage = () => {
  load.value = true;
  if (contactValidator()) {
    $alert.fire({
      title: 'Ooops!',
      text: 'Veuillez correctement remplir le formulaire',
      icon: 'error',
      confirmButtonColor: '#D62F2F',
      confirmButtonText: 'Compris'
    })
    load.value = false
  } else {
    $axios.post($endpoint.ContactUs, contactForm).then((resp: any) => {
      console.error(resp)
      $alert.fire({
        title: 'Message envoyé!',
        text: resp.data.message,
        icon: 'success',
        confirmButtonColor: '#D62F2F',
        confirmButtonText: 'Compris'
      })
      contactForm.client_message = ""
      contactForm.client_full_name = ""
      contactForm.client_object = ""
      contactForm.client_email = ""
      load.value = false
    }).catch((err: any) => {
      load.value = false
      console.error(err)
    })
  }
}

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: __props.bgImageUrl,
              alt: "Happy Family",
              class: ""
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", _hoisted_7, _toDisplayString(props.title), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(props.subtitle), 1),
            _createElementVNode("ul", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.socialLink, (socialItem, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("i", {
                        class: _normalizeClass([socialItem.icon, 'fa-2x', 'impx-text-csa'])
                      }, null, 2)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("h5", _hoisted_13, _toDisplayString(socialItem?.title), 1),
                      _createElementVNode("a", {
                        href: socialItem?.url
                      }, [
                        _createElementVNode("p", _hoisted_15, _toDisplayString(socialItem?.subtitle), 1)
                      ], 8, _hoisted_14)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      (load.value)
        ? (_openBlock(), _createBlock(LoadingSpinner, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _cache[14] || (_cache[14] = _createElementVNode("h6", { class: "uk-heading-line uk-text-center uk-light uk-text-uppercase" }, [
                _createElementVNode("span", null, "Contactez-nous")
              ], -1)),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _cache[5] || (_cache[5] = _createElementVNode("label", { class: "uk-form-label" }, "Nom complet", -1)),
                      _cache[6] || (_cache[6] = _createElementVNode("span", {
                        class: "uk-form-icon",
                        "data-uk-icon": "icon: users"
                      }, null, -1)),
                      _withDirectives(_createElementVNode("input", {
                        class: "uk-input booking-arrival uk-border-rounded",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((contactForm.client_full_name) = $event)),
                        type: "text",
                        placeholder: "Votre civilité,  Nom et prénom"
                      }, null, 512), [
                        [_vModelText, contactForm.client_full_name]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _cache[7] || (_cache[7] = _createElementVNode("label", { class: "uk-form-label" }, "Email", -1)),
                      _cache[8] || (_cache[8] = _createElementVNode("span", {
                        class: "uk-form-icon",
                        "data-uk-icon": "icon: email"
                      }, null, -1)),
                      _withDirectives(_createElementVNode("input", {
                        class: "uk-input booking-departure uk-border-rounded",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((contactForm.client_email) = $event)),
                        type: "email",
                        placeholder: "serv@exampl.com"
                      }, null, 512), [
                        [_vModelText, contactForm.client_email]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _cache[9] || (_cache[9] = _createElementVNode("label", { class: "uk-form-label" }, "Objet", -1)),
                      _cache[10] || (_cache[10] = _createElementVNode("span", {
                        class: "uk-form-icon",
                        "data-uk-icon": "icon: message"
                      }, null, -1)),
                      _withDirectives(_createElementVNode("input", {
                        class: "uk-input booking-departure uk-border-rounded",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((contactForm.client_object) = $event)),
                        type: "text",
                        placeholder: "L'objet de votre message"
                      }, null, 512), [
                        [_vModelText, contactForm.client_object]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _cache[11] || (_cache[11] = _createElementVNode("label", { class: "uk-form-label" }, "Message", -1)),
                      _cache[12] || (_cache[12] = _createElementVNode("span", {
                        class: "uk-form-icon",
                        "data-uk-icon": "icon: message"
                      }, null, -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        class: "uk-input uk-border-rounded",
                        style: {"height":"90px"},
                        cols: "16",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((contactForm.client_message) = $event)),
                        rows: "56"
                      }, "Votre message", 512), [
                        [_vModelText, contactForm.client_message]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "uk-form-label empty-label" }, " ", -1)),
                  _createElementVNode("button", {
                    class: "uk-button uk-width-1-2@xl uk-width-1-1@l uk-width-1-1@m uk-width-1-1@s",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (sendMessage()))
                  }, "Envoyer ")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})